module.exports = __webpack_public_path__ + "static/media/pdp_paperLinen.605c25b9.jpg";